import platform from "platform";

/** Every iPad browser runs the system's WebKit, so an iPad is supported by its iPadOS version. */
const IPADOS_MIN_VERSION = 17;
/** An iPhone's short side stays at or below about 440 CSS px; the smallest iPad's is 744. */
const IPAD_MIN_SHORT_SIDE = 600;

/** @param {string | null | undefined} version */
const majorVersion = (version) => (version ? Number(version.split(".")[0]) : null);

export const CHROME_VERSION = platform.version.split(".")[0];
export const isChrome = platform.name === "Chrome";
export const isSafari = platform.name?.toLowerCase() === "safari";
// an iPad asking for desktop sites reports itself as a Mac; a Mac has no touch points
export const isIOS =
  ["iOS", "OS X"].includes(platform.os?.family ?? "") && navigator.maxTouchPoints > 1;
// an iPhone asking for desktop sites reports a touch Mac too; only its screen gives it away
export const isIPhone =
  platform?.product === "iPhone" ||
  (isIOS && Math.min(screen.width, screen.height) < IPAD_MIN_SHORT_SIDE);
export const isIpad = isIOS && !isIPhone;
// an Android tablet leaves "Mobile" out of its user agent; a phone keeps it
export const isTablet =
  isIpad || (platform.os?.family === "Android" && !/Mobile/.test(platform.ua ?? ""));
/**
 * Major iPadOS version, which every iPad browser's WebKit comes with. A
 * desktop-site user agent hides it behind a frozen Mac version, but Safari's
 * own version matches it; other browsers asking for desktop sites leave it
 * unknown (null).
 */
export const IPADOS_VERSION =
  platform.os?.family === "iOS"
    ? majorVersion(platform.os.version)
    : isSafari
      ? majorVersion(platform.version)
      : null;
/** An iPad on a supported iPadOS, in any browser; an iPadOS its browser hides passes. */
export const isSupportedIpad =
  isIpad && (IPADOS_VERSION === null || IPADOS_VERSION >= IPADOS_MIN_VERSION);
